<template>
    <b-card no-body>
     <table class="table responsive">
        <thead>
            <tr>
                <th class="text-nowrap w-10">Cari Kod</th>
                <th class="text-nowrap w-25">Cari Adı</th>
                <th class="text-nowrap w-10">Fatura No</th>
                <th class="text-nowrap w-10">Tarih</th>
                <th class="text-nowrap w-10">Vade Tarihi</th>
                <th class="text-nowrap w-10">Tutar</th>
                <th class="text-nowrap w-10">Açıklama</th>
                <th class="text-nowrap w-10">Plasiyer Kodu</th>
            </tr>
        </thead>
        <tbody>
            <tr v-if="invoices.length > 0" v-for="(invoice,index) in invoices">
                <td class="text-nowrap">{{ invoice.CARI_KOD }}</td>
                <td class="text-nowrap">{{ invoice.CARI_ISIM }}</td>
                <td class="text-nowrap">{{ invoice.Belge_No }}</td>
                <td class="text-nowrap">{{ invoice.Tarih }}</td>
                <td class="text-nowrap">{{ invoice.Vade_Tarihi }}</td>
                <td class="text-nowrap">{{ invoice.BorcStr }}</td>
                <td class="text-nowrap">{{ invoice.Aciklama }}</td>
                <td class="text-nowrap">{{ invoice.Plasiyer_Kodu }}</td>
            </tr>
            <tr v-if="invoices.length <= 0" v-for="(invoice,index) in invoices">
                <td class="text-nowrap">Görüntülenecek bir kayıt bulunamadı.</td>
                
            </tr>
        </tbody>
     </table>
    </b-card>
      
</template>
<script>
import { NetsisApi } from '@/api/netsis'
import { BCard } from 'bootstrap-vue'

export default {
    components:{
        BCard
    },
    data(){
        return{
            invoices:[],
        }
    },
    mounted(){
        this.getInvoices()
    },
    methods:{
        getInvoices(){
            NetsisApi.GetLastInstallmentDayInvoices().then(res => {
                this.invoices = res.data.Data
            }).catch(err=>{
               
            })
        }

    }


}


</script>